import gql from "graphql-tag";

export const DAILY_ACTIVE_USERS_QUERY = gql`
  query dailyActiveUsersPerProduct($startDate: Date, $endDate: Date, $gymBranch: ID) {
    dailyActiveUsersPerProduct(startDate: $startDate, endDate: $endDate, gymBranch: $gymBranch) {
      cohort
      engagement {
        actionDate
        userCount
        totalUserSample
      }
    }
  }
`;
export const EVENT_VIEW_SUMMARY_QUERY = gql`
  query viewSummary($startDate: Date, $endDate: Date, $gymBranch: ID) {
    viewSummary(startDate: $startDate, endDate: $endDate, gymBranch: $gymBranch) {
      cohort
      dateSeries {
        actionDate
        userCount
        totalUserSample
      }
    }
  }
`;

export const ENGAGEMENT_PER_PRODUCT_QUERY = gql`
  query engagementPerProduct($rolling: Boolean, $startDate: Date, $endDate: Date, $gymBranch: ID) {
    engagementPerProduct(rolling: $rolling, startDate: $startDate, endDate: $endDate, gymBranch: $gymBranch) {
      cohort
      engagement {
        actionDate
        userCount
        totalUserSample
      }
    }
  }
`;

export const ENGAGEMENT_PER_TEAM_QUERY = gql`
  query engagementPerTeam($startDate: Date, $endDate: Date, $gymBranch: ID, $team: ID!) {
    engagementPerTeam(startDate: $startDate, endDate: $endDate, gymBranch: $gymBranch, team: $team) {
      cohort
      engagement {
        actionDate
        userCount
        totalUserSample
      }
    }
  }
`;

export const ENGAGEMENT_PER_PILLAR_QUERY = gql`
  query engagementPerPillar($startDate: Date, $endDate: Date, $gymBranch: ID) {
    engagementPerPillar(startDate: $startDate, endDate: $endDate, gymBranch: $gymBranch) {
      cohort
      engagement {
        actionDate
        userCount
        totalUserSample
      }
    }
  }
`;

export const COMPLIANCE_PER_WEEK_QUERY = gql`
  query weeklyCompliance($startDate: Date, $endDate: Date) {
    weeklyCompliance(startDate: $startDate, endDate: $endDate) {
      cohort
      compliance {
        actionDate
        userCount
        totalUserSample
      }
    }
  }
`;

export const ENGAGEMENT_PER_CORP_QUERY = gql`
  query engagementPerCorporate {
    engagementPerCorporate {
      cohort
      engagement {
        actionDate
        userCount
        totalUserSample
      }
    }
  }
`;

export const ACTIVITY_PER_PRODUCT_QUERY = gql`
  query activityPerProduct($startDate: Date, $endDate: Date, $gymBranch: ID) {
    activityPerProduct(startDate: $startDate, endDate: $endDate, gymBranch: $gymBranch) {
      cohort
      engagement {
        actionDate
        userCount
        totalUserSample
      }
    }
  }
`;

export const ENGAGEMENT_PER_CHALLENGE_QUERY = gql`
  query engagementPerChallenge($startDate: Date, $endDate: Date, $gymBranch: ID) {
    engagementPerChallenge(startDate: $startDate, endDate: $endDate, gymBranch: $gymBranch) {
      cohort
      engagement {
        actionDate
        userCount
        totalUserSample
      }
    }
  }
`;

export const ENGAGEMENT_PER_PREVIOUS_CHALLENGE_QUERY = gql`
  query engagementPerPreviousChallenge {
    engagementPerPreviousChallenge {
      cohort
      engagement {
        actionDate
        userCount
        totalUserSample
      }
    }
  }
`;

export const ENGAGEMENT_PER_COURSE_QUERY = gql`
  query engagementPerCourse($startDate: Date, $endDate: Date, $gymBranch: ID) {
    engagementPerCourse(startDate: $startDate, endDate: $endDate, gymBranch: $gymBranch) {
      cohort
      engagement {
        actionDate
        userCount
        totalUserSample
      }
    }
  }
`;

export const ENGAGEMENT_PER_COACH_QUERY = gql`
  query engagementPerCoach($team: String!) {
    engagementPerCoach(team: $team) {
      cohort
      engagement {
        actionDate
        userCount
        totalUserSample
      }
    }
  }
`;

export const USER_ACTIONS_QUERY = gql`
  query userActions($userId: ID, $startDate: Date) {
    userActions(userId: $userId, actionDate_Gte: $startDate) {
      edges {
        node {
          actionDate
          engagementRating
          actionSet {
            label
            type
            counter
          }
        }
      }
    }
  }
`;

export const USER_COMPLIANCE_QUERY = gql`
  query userCompliance($userId: ID, $startDate: Date) {
    userCompliance(userId: $userId, complianceDate_Gte: $startDate) {
      edges {
        node {
          complianceDate
          compliant
          isRestDay
          complianceitemSet {
            label
            type
            counter
          }
        }
      }
    }
  }
`;

export const COACH_METRIC_SUMAMRY = gql`
  query metricSummaryCoaching($team: String!, $metricDate: Date!, $cohort: String) {
    metricSummaryCoaching(team: $team, metricDate: $metricDate, cohort: $cohort) {
      id
      name
      oneOnOneClientTotal
      gradClientTotal
      oneOnOneUsersThatLoggedWorkout
      numberOfUnresolvedChats
      numberOfUnresolvedTasks
      commsPreviousDay
      oneOnOneCheckinsForMonth
      oneOnOneClientsNoProgram
      clientsAllocatedMonthToDate
      clientsLeavingMonthToDate
      clientsAllocatedPreviousMonth
      clientsLeavingPreviousMonth
      foodLogCommentsStartOfWeek
      exerciseLogCommentsStartOfWeek
      socialLikesStartOfWeek
      socialCommentsStartOfWeek
      todoPrevious30
      socialPostsStartOfMonth
    }
  }
`;

export const NUTRITION_COMPLIANCE_PER_PRODUCT_QUERY = gql`
  query nutritionCompliancePerProduct($startDate: Date, $endDate: Date) {
    nutritionCompliancePerProduct(startDate: $startDate, endDate: $endDate) {
      cohort
      compliance {
        actionDate
        userCount
        totalUserSample
      }
    }
  }
`;

export const NEW_USERS_PER_DAY_QUERY = gql`
  query newUsersPerDate($startDate: Date, $endDate: Date, $gymBranch: ID) {
    newUsersPerDate(startDate: $startDate, endDate: $endDate, gymBranch: $gymBranch) {
      dateSeries {
        actionDate
        userCount
      }
    }
  }
`;

export const RECIPIE_VIEWS_PER_DAY_QUERY = gql`
  query recipieViewsPerDate($uniqueUsers: Boolean, $startDate: Date, $endDate: Date) {
    recipieViewsPerDate(uniqueUsers: $uniqueUsers, startDate: $startDate, endDate: $endDate) {
      dateSeries {
        actionDate
        userCount
      }
    }
  }
`;

export const DOTS_LOGGED_QUERY = gql`
  query dotsLogged($startDate: Date, $endDate: Date, $gymBranch: ID) {
    dotsLogged(startDate: $startDate, endDate: $endDate, gymBranch: $gymBranch) {
      cohort
      engagement {
        actionDate
        userCount
        totalUserSample
      }
    }
  }
`;

export const SOCIAL_ACTIONS_QUERY = gql`
  query socialActions($startDate: Date, $endDate: Date, $gymBranch: ID) {
    socialActions(startDate: $startDate, endDate: $endDate, gymBranch: $gymBranch) {
      cohort
      engagement {
        actionDate
        userCount
        totalUserSample
      }
    }
  }
`;

export const EVENT_ACTIVITIY_BY_INSTRUCTOR_QUERY = gql`
  query eventActivityByInstructor($startDate: Date, $endDate: Date) {
    eventActivityByInstructor(startDate: $startDate, endDate: $endDate) {
      event {
        id
        name
        scheduledDate
        category
        instructor {
          id
          firstName
          lastName
        }
      }
      activityCount
      viewCount
    }
  }
`;
